<div [class]="getAlertCss()">
  <div class="d-flex justify-content-start alert-display">
    <div [ngClass]="size ? 'ml-2' : 'd-flex align-items-center justify-content-start'">
      <mat-icon class="mr-2 icon-display mt-1" color="primary" [style.fontSize.px]="size">
        {{icon}}
      </mat-icon>
    </div>
    <div class="mt-2 w-100">
      <ng-content>
      </ng-content>
    </div>
  </div>
</div>
